// eslint-disable-next-line import/no-cycle
import router from '@/app/app-routes';

const asyncRouterPush = route => new Promise((resolve) => {
  resolve(router.push({ path: route }));
});

export { asyncRouterPush };
